(function () {
  function initializeFounderVideo(root) {
    var button = root.querySelector('[data-drka-video-play]');
    var frame = root.querySelector('[data-drka-video]');
    if (!button || !frame || button.dataset.ready === 'true') return;

    button.dataset.ready = 'true';
    button.addEventListener('click', function () {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://player.vimeo.com/video/1216707657?h=2730d45894&title=0&byline=0&portrait=0&autoplay=1';
      iframe.title = 'Dr. Knot founder story video';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.setAttribute('allowfullscreen', '');
      frame.replaceChildren(iframe);
    });
  }

  function initializeAll() {
    document.querySelectorAll('.drk-about-story').forEach(initializeFounderVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
})();
